import { useTranslation } from "react-i18next";
import { complexDigitToman, convertToJalaliWithoutTime } from "../../../../tools/tools";
import { useDealer } from "../../../../tools/api";
import ReportPage, { col } from "../../../auxiliary/report/ReportPage";

const DCReport = () => {
	const [t] = useTranslation("global");
	const { queryDCPurchaseDealerByDate } = useDealer();

	return (
		<ReportPage
			title={t("directCharge.report.title")}
			prefix="dc"
			query={queryDCPurchaseDealerByDate}
			columns={[
				col("نام کاربری", "username"),
				col("شماره", "msisdn"),
				col("قیمت (تومان)", "price"),
				col("سودفروش (تومان)", "commission"),
				col("تاریخ خرید", "purchaseDate"),
				col("وضعیت", "status"),
			]}
			toRow={(item) => ({
				username: item.username,
				msisdn: item.msisdn,
				price: complexDigitToman(item.chargamount),
				commission: complexDigitToman(item.commision),
				purchaseDate: convertToJalaliWithoutTime(item.purchasedate),
				status: item.state,
			})}
			excel={{ sheet: "گزارشات فروش شارژ", file: "charge-sales-report.xlsx" }}
		/>
	);
};

export default DCReport;
